module.exports = __webpack_public_path__ + "img/stepicons-arei.6ac273e3.svg";